import TransparencyButton from '../../sub/transparencyButton';
import * as React from 'react';

export const NativeTransparencyButton = ({ adObj, className = '' }) => {
    return (
        <div
            className={`order-first text-12 absolute top-0 right-0 z-1 ${className}`}
        >
            <TransparencyButton
                adObj={adObj}
                style={{
                    filter: '',
                    opacity: 0.6,
                }}
                placement="right"
            />
        </div>
    );
};
